import { render, staticRenderFns } from "./LawaCard.vue?vue&type=template&id=3c0e39bf&"
import script from "./LawaCard.vue?vue&type=script&lang=js&"
export * from "./LawaCard.vue?vue&type=script&lang=js&"
import style0 from "./LawaCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports